/* eslint-disable react/sort-comp */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-access-state-in-setstate */
import React, { Component } from 'react';
import {
  TextInput,
  Button,
  FormGroup,
  ComposedModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Checkbox,
  DropdownSkeleton,
  TextArea,
} from 'carbon-components-react';
import SimpleReactValidator from 'simple-react-validator';
import { v4 as uuid } from 'uuid';
import { FindGHRSEmployer } from '../common/FindGHRSEmployer';
import { ComboBox } from '../../helpers/ComboBox';
import { CarType, DateFormat, entitiesLabels } from '../../helpers/Constants';
import { showNotification } from '../../helpers/notification/BaseNotification';
import DateTimePicker from '../../helpers/DateTimePicker';
import moment from 'moment';
import Close16 from '@carbon/icons-react/lib/close/16';

export default class AuditCAModal extends Component {
  auditCARModel = (props) => {
    if (props.isEditModal) {
      const { editModel } = props;
      return { ...editModel };
    }

    return {
      id: undefined, // guid
      idAuditCAR: undefined, // guid
      caImplemented: null, // ''
      idOwner: null, // idInvolvedPerson: null,  //guid
      owner: {
        // InvolvedPerson: {
        id: null, // guid
        type: '',
        badgeNumber: '',
        fullname: '',
        nationality: '',
        email: '',
        position: '',
        idEmployer: null, // guid
      },
      dueDate: null,
      dueDateChangeNotes: null, // ''
      immediateThreatment: null,
      immediateTreatmentNC: null,
      idStatus: 1,
      causeOfInefficiency: null, // ''
      explain: null, // ''
      isAdequate: undefined, // bool
      evidencesAttached: undefined, // bool
      checkEffectiveness: null, // ''
      dateCheck: null, // date
      isCorrectiveActionsSuitable: null, //RITM0945960
    };
  };

  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();
    this.validatorReminder = new SimpleReactValidator(); //RITM1010580/RITM1010550
    this.state = {
      model: {
        ...this.auditCARModel(props),
        },
        maskedValue: this.props.maskedValue, //RITM1133680 Anonimization_AUDIT_Pending_UI
      mode: 0,

      appType: props.appType,
      appNationality: props.appNationality,
      appRecommendation: props.appRecommendation,
      appCorrectiveActionsSuitable: [ //RITM0945960
        { id: 'option-1', text: 'Yes' },
        { id: 'option-2', text: 'No' },

    ],
    };
  }

  componentDidMount() {}

  handleChangeMode = (m) => {
    this.setState({ mode: m });
  };

  updateState = (inputName, inputValue, objName) => {
    const statusCopy = { ...this.state.model };
    if (objName && objName != 'model') statusCopy[objName][inputName] = inputValue;
    else statusCopy[inputName] = inputValue;

    this.setState({ model: statusCopy });
  };

  handleChangeModel = (el) => {
    const inputName = el.target.name;
    const inputValue = el.target.value;
    const objName = el.target.alt;

    this.updateState(inputName, inputValue, objName);
  };

  handleChangeCombo = (inputName, selectedItem, objName) => {
    const inputValue = selectedItem ? selectedItem.id : null;
    this.updateState(inputName, inputValue, objName);
  };

  handleChangeComboName = (inputName, selectedItem, objName) => {
    if (selectedItem != null) {
      selectedItem.id = selectedItem.name;
    }
    this.handleChangeCombo(inputName, selectedItem, objName);
  };

  setEmployer = (employer) => {
    if (employer && employer.id) {
      const statusCopy = { ...this.state.model };

      statusCopy.owner.idEmployer = employer.id;
      statusCopy.owner.badgeNumber = employer.ghrS_ID;
      statusCopy.owner.fullname = employer.fullname;
      statusCopy.owner.email = employer.email;
      statusCopy.owner.type = 'Saipem';
      const country = (this.state.appNationality || []).find((el) => el.id == employer.countryId);
      statusCopy.owner.nationality = country ? country.name : '';

      this.setState({ model: statusCopy, mode: 2 });
    }
  };

  save = () => {
    //RITM1010580/RITM1010550 – Audit CA Mandatory Fields Fix
    if (this.props.car.idStatus === 4) {
      if (this.validatorReminder.allValid() && this.validator.allValid()) {
          const { model } = this.state;
          if (!this.props.isEditModal) {
            model.id = uuid();
            model.idOwner = uuid();
            model.owner.id = model.idOwner;
          }
          this.props.save(model);
      }
      else {
        if (!this.validatorReminder.allValid()) {
          this.validatorReminder.showMessages();
          showNotification.warning(`${entitiesLabels.WARNING}`, `${entitiesLabels.CA} required fields are missing  `);
          this.forceUpdate();
        } 
        else {
          if (this.validator.fieldValid('duedate') == false) {
            showNotification.warning(
              `${entitiesLabels.WARNING}`,
              `The Due Date must be less than or equal to the Due Date of the Finding `
            );
          } else {
            showNotification.warning(
              `${entitiesLabels.WARNING}`,
              ` ${entitiesLabels.CA} required fields are missing  `
            );
          }
          this.validator.showMessages();
    
          this.forceUpdate();
        }
      }    
    }
    else {
      if (this.validator.allValid()) {
        const { model } = this.state;
        if (!this.props.isEditModal) {
          model.id = uuid();
          model.idOwner = uuid();
          model.owner.id = model.idOwner;
        }
        this.props.save(model);
      } else {
        if (this.validator.fieldValid('duedate') == false) {
          showNotification.warning(
            `${entitiesLabels.WARNING}`,
            `The Due Date must be less than or equal to the Due Date of the Finding `
          );
        } else {
          showNotification.warning(
            `${entitiesLabels.WARNING}`,
            ` ${entitiesLabels.CA} required fields are missing  `
          );
        }
        this.validator.showMessages();
  
        this.forceUpdate();
      }
    }
    //End
  };

  deleteEmployer = () => {
    let statusCopy = Object.assign({}, this.state.model);
    statusCopy.owner.idEmployer = null;
    statusCopy.owner.type = null;
    statusCopy.owner.badgeNumber = null;
    statusCopy.owner.fullname = null;
    statusCopy.owner.nationality = null;
    statusCopy.owner.email = null;
    this.setState({ model: statusCopy });
  };

  render() {
    if (this.state.model.dueDate != null) {
      var diffduedate =
        !this.props.car.dueDate ||
        moment(this.props.car.dueDate).isSameOrAfter(moment(this.state.model.dueDate), 'day');
    } else {
      var diffduedate = true;
    }
    const validations = {
      type: this.validator.message('type', this.props.isNewCarManagement === 0 ? this.state.model.owner.type : true, 'required'),
      fullname: this.validator.message('fullname', this.props.isNewCarManagement === 0 ? this.state.model.owner.fullname : true, 'required'),
      badgeNumber: this.validator.message(
        'badgeNumber',
        this.props.isNewCarManagement === 0 ? this.state.model.owner.badgeNumber : true,
        'required'
      ),
      email: this.validator.message('email',  this.props.isNewCarManagement === 0 ?  this.state.model.owner.email : 'xxx@yyy.com', 'required|email' ),
      // nationality: this.validator.message('nationality', this.state.model.owner.nationality, 'required'),
      position: this.validator.message('position', this.props.isNewCarManagement === 0 ? this.state.model.owner.position : true, 'required'),
      duedate: this.validator.message('duedate', diffduedate, 'accepted'),
      dueDate: this.validator.message('dueDate', this.state.model.dueDate, 'required'),
      immediateTreatmentNC: this.validator.message(
        'immediateTreatmentnc',
        this.props.car.carType == CarType.NC.Code ? this.state.model.immediateThreatmentNC : true,
        'required'
      ),
      causeOfInefficiency: this.validator.message(
        'causeOfInefficiency',
        this.state.model.causeOfInefficiency,
        'required'
      ),
      caImplemented: this.validator.message(
        'caImplemented',
        this.state.model.caImplemented,
        'required'
      ),      
    };
    //RITM1010580/RITM1010550 – Audit CA Mandatory Fields Fix
    const validationsReminder = {
      checkEffectiveness: this.validatorReminder.message(
          'checkEffectiveness',
          (this.props.car.carType === CarType.NC.Code || 
            this.props.car.carType === CarType.OBS.Code) ? 
            this.state.model.checkEffectiveness : true,
           'required'),
      dateCheck: this.validatorReminder.message(
            'dateCheck', 
            (this.props.car.carType === CarType.NC.Code || 
              this.props.car.carType === CarType.OBS.Code) ? 
              this.state.model.dateCheck : true, 
              'required'),
      //RITM0945960 - Effectiveness Check Modification
      isCorrectiveActionsSuitable: this.validatorReminder.message( 
            'isCorrectiveActionsSuitable',
            (this.props.car.carType === CarType.NC.Code ||
              this.props.car.carType === CarType.OBS.Code) ?
              this.state.model.isCorrectiveActionsSuitable : true,
              'required'),
      //End
    };
    //End
    
    const modalHeader = {
      title: this.props.isEditModal ? 'Edit ' : 'Add new ',
      iconDescription: 'Close',
      buttonOnClick: () => this.props.toggleModal(false),
    };
    const { title, isOpenModal } = this.props;

    //RITM1197573
    const appType = (this.state.appType || []).filter(
      (el) => (el.inUse) || this.state.model?.owner.type == el.id);

    const selectedItemCombo = {
      nationality: (this.state.appNationality || []).find(
        (el) => el.name == this.state.model.owner.nationality
      ),
      type: (appType || []).find((el) => el.id == this.state.model.owner.type), //RITM1197573
      idStatus: (this.props.appStatus || []).find((el) => el.id == this.state.model.idStatus),
      isCorrectiveActionsSuitable: (this.state.appCorrectiveActionsSuitable || []).find( //RITM0945960
        (el) => el.text == this.state.model.isCorrectiveActionsSuitable
      ),
    };

    return this.state.mode === 1 ? (
      <FindGHRSEmployer
        isOpenModal={isOpenModal}
        onCancel={this.handleChangeMode}
        onOk={this.setEmployer}
      />
    ) : (
      <ComposedModal
        className="light-modal"
        open={isOpenModal}
        danger="false"
        onClose={() => false}
      >
        <ModalHeader className="margin-modal" {...modalHeader}>
          <p>{title || ''}</p>
        </ModalHeader>
        <ModalBody className="margin-modal">
          <div className="bx--grid--full-width">
            {this.props.car.carType == CarType.NC.Code ? (
              <div className="bx--col--md-12 bx--col-lg-12">
                <FormGroup legendText={this.props.isNewCarManagement > 0 ? "Correction (immediate treatment) *" : "Immediate Treatment *"} >
                  <TextArea
                    maxLength={5000}
                    id="immediateTreatmentNC"
                    placeholder={this.props.isNewCarManagement > 0 ? "Input Correction" : "Input Immediate Treatment"} 
                    value={this.state.model.immediateThreatmentNC || ''}
                    onChange={(el) =>
                      this.updateState('immediateThreatmentNC', el.target.value, 'model')
                    }
                    hideLabel
                    labelText=""
                    light
                    rows={4}
                    cols={200}
                    invalid={validations.immediateTreatmentNC != null}
                    disabled={this.props.isDisabled}
                  />
                  {validations.immediateTreatmentNC}
                </FormGroup>
              </div>
            ) : (
              ''
            )}
            <div className="bx--row">
              <div className="bx--col--md-12 bx--col-lg-12">
                <FormGroup legendText="Cause of inefficiency *">
                  <TextArea
                    maxLength={5000}
                    id="causeOfInefficiency"
                    placeholder="Input Cause of inefficiency"
                    value={this.state.model.causeOfInefficiency || ''}
                    onChange={(el) =>
                      this.updateState('causeOfInefficiency', el.target.value, 'model')
                    }
                    hideLabel
                    labelText=""
                    light
                    rows={4}
                    cols={200}
                    invalid={validations.causeOfInefficiency != null}
                    disabled={this.props.isDisabled}
                  />
                  {validations.causeOfInefficiency}
                </FormGroup>
              </div>
              <div className="bx--col--md-12 bx--col-lg-12">
                <FormGroup
                  legendText={
                    this.props.car.carType == CarType.NC.Code
                      ? 'Corrective action to be implemented *'
                      : 'Corrective action to be implemented/Recommended Action *'
                  }
                >
                  <TextArea
                    maxLength={5000}
                    id="caImplemented"
                    placeholder="Input Corrective action"
                    value={this.state.model.caImplemented || ''}
                    onChange={(el) => this.updateState('caImplemented', el.target.value, 'model')}
                    hideLabel
                    labelText=""
                    light
                    rows={4}
                    cols={200}
                    invalid={validations.caImplemented != null}
                    disabled={this.props.isDisabled}
                  />
                  {validations.caImplemented}
                </FormGroup>
              </div>
              <div className="bx--col-md-8 bx--col-lg-6">
              {this.props.isNewCarManagement === 0 ? (
                <FormGroup legendText="Find Owner on GHRS*">
                  <div className="bx--row">
                  <div class="incident-GHRS-button">
                      <Button
                        kind="primary"
                        className="bx--col"
                        onClick={() => this.handleChangeMode(1)}
                        disabled={this.state.maskedValue} //RITM1133680 Anonimization_AUDIT_Pending_UI
                      >
                        GHRS research
                      </Button>
                    </div>
                    <div>
                      <Button
                        iconDescription="Remove Owner"
                        tooltipPosition="top"
                        tooltipAlignment="center"
                        hasIconOnly
                        renderIcon={Close16}
                        onClick={() => this.deleteEmployer()}
                        className="search--custom-button"
                        disabled={this.state.maskedValue} //RITM1133680 Anonimization_AUDIT
                      />
                    </div>          
                    </div>           
                  </FormGroup> )
                : ""
              }
              </div>
              <div className="bx--col-md-4 bx--col-lg-6">
                {this.props.isNewCarManagement === 0 ? (
                  <FormGroup legendText="Type*">
                    {appType == null ? ( //RITM1197573
                      <DropdownSkeleton />
                    ) : (
                      <ComboBox
                        id="type"
                        key={this.state.model.owner?.type}
                        placeholder="Select"
                        name="type"
                        alt="owner"
                        onChange={this.handleChangeCombo}
                        itemToString={(item) => (item ? item.name : '')}
                        initialSelectedItem={selectedItemCombo.type}
                        items={appType} //RITM1197573
                        disabled={this.state.model.owner.idEmployer != null || this.props.isDisabled}
                        invalid={validations.type != null}
                      />
                    )}
                    {validations.type}
                  </FormGroup>)
                  : ""
                }
              </div>
              <div className="bx--col-md-4 bx--col-lg-6">
                {this.props.isNewCarManagement === 0 ? (
                  <FormGroup legendText="Owner Full name*">
                    <TextInput
                      id="txt-fullname"
                      name="fullname"
                      alt="owner"
                      placeholder="Input full name"
                      value={this.state.model.owner.fullname || ''}
                      onChange={this.handleChangeModel}
                      type="text"
                      hideLabel
                      labelText=""
                      disabled={this.state.model.owner.idEmployer != null || this.props.isDisabled}
                      invalid={validations.fullname != null}
                    />
                    {validations.fullname}
                  </FormGroup>)
                  : ""
                }
              </div>
              <div className="bx--col-md-4 bx--col-lg-6">
                {this.props.isNewCarManagement === 0 ? (
                  <FormGroup legendText="Owner Badge number*">
                    <TextInput
                      id="badgeNumber"
                      name="badgeNumber"
                      alt="owner"
                      placeholder="Input badge number"
                      value={this.state.model.owner.badgeNumber || ''}
                      onChange={this.handleChangeModel}
                      type="text"
                      hideLabel
                      labelText=""
                      disabled={this.state.model.owner.idEmployer != null || this.props.isDisabled}
                      invalid={validations.badgeNumber != null}
                    />
                    {validations.badgeNumber}
                  </FormGroup>)
                  : ""
                }
              </div>
              <div className="bx--col-md-4 bx--col-lg-6">
                {this.props.isNewCarManagement === 0 ? (
                  <FormGroup legendText="Owner Email* (Personal Email Addresses are not allowed)">
                    <TextInput
                      id="email"
                      name="email"
                      alt="owner"
                      placeholder="Input email"
                      value={this.state.model.owner.email || ''}
                      onChange={this.handleChangeModel}
                      type="text"
                      title="&#9888; Do Not use Personal Accounts"
                      hideLabel
                      labelText=""
                      disabled={this.state.model.owner.idEmployer != null || this.props.isDisabled}
                      invalid={validations.email != null}
                    />
                    {validations.email}
                  </FormGroup>)
                  : ""
                }
              </div>
              <div className="bx--col-md-4 bx--col-lg-6">
                {this.props.isNewCarManagement === 0 ? (
                  <FormGroup legendText="Owner Nationality">
                    {this.state.appNationality == null ? (
                      <DropdownSkeleton />
                    ) : (
                      <ComboBox
                        id="nationality"
                        key={this.state.model.owner?.nationality != null}
                        placeholder="Select"
                        name="nationality"
                        alt="owner"
                        onChange={this.handleChangeComboName}
                        itemToString={(item) => (item ? item.name : '')}
                        initialSelectedItem={selectedItemCombo.nationality}
                        items={this.state.appNationality}
                        disabled={this.state.model.owner.idEmployer != null || this.props.isDisabled}
                        // invalid={validations.nationality != null}
                      />
                    )}
                    {/* {validations.nationality} */}
                  </FormGroup>)
                  : ""
                }
              </div>
              <div className="bx--col-md-4 bx--col-lg-6">
                {this.props.isNewCarManagement === 0 ? (
                  <FormGroup legendText="Position *">
                    <TextInput
                      id="position"
                      name="position"
                      alt="owner"
                      placeholder="Input position"
                      value={this.state.model.owner.position || ''}
                      onChange={this.handleChangeModel}
                      type="text"
                      hideLabel
                      labelText=""
                      invalid={validations.position != null}
                      disabled={this.props.isDisabled}
                    />
                    {validations.position}
                  </FormGroup>)
                  : ""
                }
              </div>
              <div className="bx--col-lg-6 bx--col-md-4">
                <FormGroup legendText="Status*">
                  {this.props.appStatus == null ? (
                    <DropdownSkeleton />
                  ) : (
                    <ComboBox
                      id="idStatus"
                      placeholder="Select"
                      name="idStatus"
                      alt="model"
                      onChange={this.handleChangeCombo}
                      itemToString={(item) => (item ? item.caManagementName : '')}
                      initialSelectedItem={selectedItemCombo.idStatus}
                      items={this.props.appStatus}
                      disabled
                    />
                  )}
                </FormGroup>
              </div>
              <div className="bx--col-md-4 bx--col-lg-6">
                <FormGroup legendText="Due Date*">
                  <DateTimePicker
                    value={this.state.model.dueDate}
                    type="date"
                    placeholder={DateFormat}
                    name="dueDate"
                    alt="model"
                    invalid={validations.dueDate != null || validations.duedate != null}
                    onChange={this.updateState}
                    disabled={this.props.isDisabled}
                    className="open-up"
                  />

                  {validations.dueDate}
                  {validations.duedate ? (
                    <div className="srv-validation-message">
                      The Due Date must be less than or equal to the Due Date of the Finding
                    </div>
                  ) : null}
                </FormGroup>
              </div>
              <div className="bx--col-md-4 bx--col-lg-6">
                <FormGroup legendText="Due Date Change Notes">
                  <TextInput
                    id="dueDateChangeNotes"
                    name="dueDateChangeNotes"
                    alt="model"
                    placeholder="Input change notes"
                    value={this.state.model.dueDateChangeNotes || ''}
                    onChange={this.handleChangeModel}
                    type="text"
                    hideLabel
                    labelText=""
                    disabled={this.props.isDisabled}
                  />
                </FormGroup>
              </div>
              {this.props.editEffectiveness && (
                <>
                  <div className="bx--col-md-4 bx--col-lg-6">
                    <FormGroup legendText="Audit Team has analyzed the Corrective Action and their evidences of closing and has assessed them as adequate">
                      <Checkbox
                        id="isAdequate"
                        alt="model"
                        labelText=""
                        checked={this.state.model.isAdequate || false}
                        onChange={(value, id) => this.updateState(id, value, 'model')}
                      />
                    </FormGroup>
                  </div>
                  <div className="bx--col-md-4 bx--col-lg-6">
                    <FormGroup legendText="Evidences are attached">
                      <Checkbox
                        id="evidencesAttached"
                        alt="model"
                        labelText=""
                        checked={this.state.model.evidencesAttached || false}
                        onChange={(value, id) => this.updateState(id, value, 'model')}
                      />
                    </FormGroup>
                  </div>
                  <div className="bx--col--md-12 bx--col-lg-12">
                    <FormGroup legendText="Check of the effectiveness of the CA">
                      <TextArea
                        maxLength={5000}
                        id="checkEffectiveness"
                        placeholder="Check of the effectiveness of the CA"
                        value={this.state.model.checkEffectiveness || ''}
                        onChange={(el) =>
                          this.updateState('checkEffectiveness', el.target.value, 'model')
                        }
                        hideLabel
                        labelText=""
                        light
                        rows={4}
                        cols={200}
                        invalid={validationsReminder.checkEffectiveness != null} //RITM0945960 //RITM1010580/RITM1010550 
                      />
                    </FormGroup>
                    {/* //RITM0945960 //RITM1010580/RITM1010550 */}
                    {validationsReminder.checkEffectiveness}
                  </div>
                  <div className="bx--col-md-4 bx--col-lg-6">
                    <FormGroup legendText="Date of the effectiveness check">
                      <DateTimePicker
                        value={this.state.model.dateCheck}
                        type="date"
                        placeholder={DateFormat}
                        name="dateCheck"
                        alt="model"
                        onChange={this.updateState}
                        className="open-up"
                        invalid={validationsReminder.dateCheck != null} //RITM0945960 //RITM1010580/RITM1010550 
                      />
                    </FormGroup>
                    {/* //RITM0945960 //RITM1010580/RITM1010550 */}
                    {validationsReminder.dateCheck}
                  </div>
                  {/* RITM0945960 - Effectiveness Check Modification */}
                  <div className="bx--col-md-4 bx--col-lg-6">
                    <FormGroup legendText="Is the corrective actions suitable for the purpose?*">
                      <ComboBox
                          id="isCorrectiveActionsSuitable"
                          placeholder="Select"
                          name="isCorrectiveActionsSuitable"
                          alt="model"
                          onChange={(id, val) =>
                            this.updateState(id, (val ? val.text : null), 'model')}
                          itemToString={item => (item ? item.text : '')}
                          initialSelectedItem={selectedItemCombo.isCorrectiveActionsSuitable || null}
                          items={this.state.appCorrectiveActionsSuitable} 
                          invalid={validationsReminder.isCorrectiveActionsSuitable != null}    //RITM1010580/RITM1010550                                                                              
                      />                            
                    </FormGroup> 
                    {/* //RITM1010580/RITM1010550  */}
                    {validationsReminder.isCorrectiveActionsSuitable}               
                 </div>
                 {/* End */}
                </>
              )}
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button kind="secondary" onClick={() => this.props.toggleModal(false)}>
            Cancel
          </Button>
          <Button
            kind="primary"
            disabled={this.props.isDisabled && !this.props.editEffectiveness}
            onClick={() => this.save()}
          >
            Save
          </Button>
        </ModalFooter>
      </ComposedModal>
    );
  }
}
